import { MainPropertyType } from '@aloft/toolkit-shared';

export function getCostQualityRange(type: MainPropertyType) {
  switch (type) {
    case 'manufacturedHome':
      return {
        min: 1,
        max: 5,
        labels: [
          '1 - Best Quality',
          '2 - Good Quality',
          '3 - Average Quality',
          '4 - Low Quality',
          '5 - Lowest Quality',
        ],
        getLabel(value: number) {
          if (value >= 1 && value < 1.5) return 'Best Quality';
          if (value >= 1.5 && value < 2.5) return 'Good Quality';
          if (value >= 2.5 && value < 3.5) return 'Average Quality';
          if (value >= 3.5 && value < 4.5) return 'Low Quality';
          if (value >= 4.5 && value <= 5) return 'Lowest Quality';

          return '';
        },
      };
    case 'multiFamily':
      return {
        min: 1,
        max: 5,
        labels: [
          '1 - Best Quality',
          '2 - Good Quality',
          '3 - High Average Quality',
          '4 - Low Average Quality',
          '5 - Minimum Quality',
        ],
        getLabel(value: number) {
          if (value >= 1 && value < 1.5) return 'Best Quality';
          if (value >= 1.5 && value < 2.5) return 'Good Quality';
          if (value >= 2.5 && value < 3.5) return 'High Average Quality';
          if (value >= 3.5 && value < 4.5) return 'Low Average Quality';
          if (value >= 4.5 && value <= 5) return 'Minimum Quality';

          return '';
        },
      };
    case 'singleFamilyResidence':
    default:
      return {
        min: 1,
        max: 6,
        labels: [
          '1 - Luxury',
          '2 - Semi-Luxury',
          '3 - Best Standard',
          '4 - Good Standard',
          '5 - Average Standard',
          '6 - Minimum Standard',
        ],
        getLabel(value: number) {
          if (value >= 1 && value < 1.5) return 'Luxury';
          if (value >= 1.5 && value < 2.5) return 'Semi-Luxury';
          if (value >= 2.5 && value < 3.5) return 'Best Standard';
          if (value >= 3.5 && value < 4.5) return 'Good Standard';
          if (value >= 4.5 && value < 5.5) return 'Average Standard';
          if (value >= 5.5 && value <= 6) return 'Minimum Standard';

          return '';
        },
      };
  }
}
